// src/auth/Callback.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import userManager from "./oidcConfig";

const Callback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Processing login...");

  useEffect(() => {
    const processCallback = async () => {
      try {
        setStatus("Processing authentication callback...");

        // Process the callback
        await userManager.signinRedirectCallback();

        setStatus("Verifying authentication...");

        // Wait a moment and verify the user is properly stored
        await new Promise((resolve) => setTimeout(resolve, 500));

        const user = await userManager.getUser();

        if (user && user.access_token) {
          setStatus("Login successful! Redirecting...");
          console.log(
            "Login successful, user authenticated:",
            user.profile.name
          );

          // Small delay to ensure everything is properly set up
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          throw new Error("User not properly authenticated after callback");
        }
      } catch (error) {
        console.error("Login callback failed:", error);
        setStatus("Login failed. Redirecting to login page...");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    };

    processCallback();
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        fontSize: "18px",
      }}
    >
      <div>🔑 {status}</div>
      <div
        style={{
          marginTop: "20px",
          fontSize: "14px",
          color: "#666",
        }}
      >
        This may take a few seconds...
      </div>
    </div>
  );
};

export default Callback;
